import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Container, Button } from '@mui/material';
import UsePendingList from '../../hooks/UsePendingListings';
import '../../assets/css/stylesheets/pages/EmployeeDirectoryUpdates/PendingDirectoryListings.css'
import UpdateListingForm from '../../components/form/UpdateListingForm'
import { UpdateListingFormProvider } from '../../contexts/UpdateListingFormContext';

const PendingDirectoryListings = () => {


    const { listings, selectedRecords, selectedListing, currentPage, totalPages, paginatedResults, handleCheckboxChange, handleSelectClick, setCurrentPage, handleDeletePendingListing } = UsePendingList();


    return (
        <Container className="mt-5">
            <h4>Pending Listings</h4>
            <Row className="grid-header">
                <Col className="center-text">Select Listing</Col>
                <Col className="center-text">State</Col>
                <Col className="center-text">First Name or Org Name</Col>
                <Col className="center-text">Last Name or Owner Name</Col>
                <Col className="center-text">Customer #</Col>
                <Col className="center-text">Email</Col>
            </Row>
            {Array.isArray(paginatedResults) && paginatedResults.length > 0 ? (
                paginatedResults.map(listing => (
                    <Row key={listing.ID} className={`grid-row ${selectedRecords.includes(listing.ID) ? 'highlight' : ''}`}>
                        <Col className="center-text">
                            <input
                                type="checkbox"
                                checked={selectedRecords.includes(listing.ID)}
                                onChange={() => handleCheckboxChange(listing.ID)}
                            />
                        </Col>
                        <Col className="center-text">{listing.StateProvince}</Col>
                        <Col className="center-text">{listing.FirstName ? listing.FirstName : listing.OrganizationName}</Col>
                        <Col className="center-text">{listing.LastName ? listing.LastName : listing.OwnerName}</Col>
                        <Col className="center-text">{listing.CustomerNumber}</Col>
                        <Col className="center-text">{listing.Email}</Col>
                    </Row>
                ))
            ) : (
                <Row className="grid-row">
                    <Col className="center-text">No pending listings found.</Col>
                </Row>
            )}
            <div className="pagination-controls mt-3">
                <Button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}>
                    Previous
                </Button>
                <span>{`Page ${currentPage} of ${totalPages}`}</span>
                <Button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}>
                    Next
                </Button>
            </div>
            <div className="action-buttons mt-3">
                <Button onClick={handleSelectClick}>Select Pending Listing</Button>
                {selectedRecords.length > 0 && (
                    <Button 
                        variant="contained" 
                        color="error" 
                        onClick={() => handleDeletePendingListing(selectedRecords[0])}
                        className="ml-2"
                    >
                        Delete Listing
                    </Button>
                )}
            </div>
            {selectedListing && (
                <UpdateListingFormProvider startPlanOption={selectedListing?.SiteType != null ? 'PR' : selectedListing?.Picture != null ? 'P' : 'B'} customerNumber={selectedListing.CustomerNumber} modelType="pending">
                    <UpdateListingForm listing={selectedListing} />
                </UpdateListingFormProvider>
            )}
        </Container>
    );
};

export default PendingDirectoryListings;